import type { ReactNode } from "react";
import { Icono } from "./Icono";

const FOCO = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2";

// Panel deslizante desde el borde derecho — mismo contrato de props que
// Modal.tsx, pero anclado al costado en vez de centrado (para contenido
// como filtros, donde un diálogo centrado quedaría demasiado angosto).
// Reutiliza la receta fixed + overlay + transición translate-x que ya usa
// Sidebar.tsx para su drawer móvil, sólo que deslizando desde la derecha.
export function PanelLateral({
  titulo,
  abierto,
  onCerrar,
  children,
  ancho = "max-w-sm",
}: {
  titulo: string;
  abierto: boolean;
  onCerrar: () => void;
  children: ReactNode;
  ancho?: string;
}) {
  return (
    <>
      {abierto && (
        <div className="fixed inset-0 z-50 bg-principal/40" onClick={onCerrar} aria-hidden="true" />
      )}
      <div
        className={`fixed inset-y-0 right-0 z-50 flex w-full ${ancho} flex-col border-l border-borde bg-superficie shadow-xl transition-transform duration-200 ease-in-out ${
          abierto ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between border-b border-borde px-5 py-4">
          <h2 className="text-base font-semibold text-texto">{titulo}</h2>
          <button
            onClick={onCerrar}
            aria-label="Cerrar"
            className={`rounded-md p-1 text-texto-secundario transition-colors hover:bg-fondo hover:text-texto ${FOCO}`}
          >
            <Icono nombre="cerrar" className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
      </div>
    </>
  );
}
